import React from 'react'

export default ({ children }: any) => {
  return <div style={{ height: '100%', display: 'flex' }}>{children}</div>
}
